import React from "react";

const Linkify = ({ children }) => {
  const isUrl = word => {
    const urlPattern = /^http/;
    return word.match(urlPattern)
  }

  const addMarkup = word => {
    return isUrl(word) ?
      `<a href="${word}" target="_blank" >${word}</a>` :
      word
  }

  if(typeof children != 'string'){
    return <>{children}</>
  }
  const words = children.split(' ')
  const formatedWords = words.map((w, i) => addMarkup(w))
  const html = formatedWords.join(' ')
  return (<span dangerouslySetInnerHTML={{ __html: html }} />)
}
export default Linkify